import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_accents_artificial_plants: FaireCategoryEntity = {
  token: "cat_accents-artificial-plants",
  type: "category",
  name: "Artificial plants",
  level: 3,
  parentToken: "cat_home-decor-accents",
  href: "/category/home-decor/home-accents/artificial-plants",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
